var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHugeiconsTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 4.16663H33.3332C37.2623 4.16663 39.2248 4.16663 40.4457 5.38746C41.6665 6.60829 41.6665 8.57079 41.6665 12.5V25C41.6665 28.9291 41.6665 30.8916 40.4457 32.1125C39.2248 33.3333 37.2623 33.3333 33.3332 33.3333H18.7498M20.8332 13.5416H33.3332M4.1665 35.4166V27.0833C4.1665 25.1187 4.1665 24.1375 4.77692 23.527C5.38734 22.9166 6.36859 22.9166 8.33317 22.9166H12.4998M4.1665 35.4166H12.4998M4.1665 35.4166V45.8333M12.4998 22.9166V35.4166M12.4998 22.9166H24.9998M12.4998 35.4166V45.8333",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 13.5417C12.4998 14.6467 12.0609 15.7065 11.2794 16.4879C10.498 17.2693 9.43824 17.7083 8.33317 17.7083C7.2281 17.7083 6.16829 17.2693 5.38689 16.4879C4.60549 15.7065 4.1665 14.6467 4.1665 13.5417C4.1665 12.4366 4.60549 11.3768 5.38689 10.5954C6.16829 9.81399 7.2281 9.375 8.33317 9.375C9.43824 9.375 10.498 9.81399 11.2794 10.5954C12.0609 11.3768 12.4998 12.4366 12.4998 13.5417Z",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsTeacher);
export default __webpack_public_path__ + "static/media/hugeicons_teacher.1c2a504761cfd7b4edd4199ad8d8e8c5.svg";
export { ForwardRef as ReactComponent };